<template>
  <div id="virtual_attendee_faq" style="display: none;" class="faq">
    <VirtualDelegateAttendeeFAQ v-if="$store.state.attendee.type == 'delegate'"/>
    <VirtualSupplierAttendeeFAQ v-if="$store.state.attendee.type == 'supplier'"/>
  </div>
</template>

<script>
import VirtualDelegateAttendeeFAQ from './VirtualDelegateAttendeeFAQ.vue'
import VirtualSupplierAttendeeFAQ from './VirtualSupplierAttendeeFAQ.vue'

export default {
  name: 'VirtualAttendeeFAQ',
  components: { VirtualDelegateAttendeeFAQ, VirtualSupplierAttendeeFAQ }
}
</script>
